/** Colors sampled from the role-play illustrations (see webApp/src/features/RolePlay/IMAGE_STYLE.md). */
export const palette = {
  teal: '#0492a8',
  vermilion: '#f04a13',
  cream: '#f4ede1',
  charcoal: '#22282c',
} as const;
